import { vsLookupManagementServiceProviderName } from "./lookupManagement";
import { simpleLookupManagementConfig } from "../../../../records/lookup/utils/simpleLookupManagementConfig";

export const vsObjectName = "gamingContractPerformanceGuaranteeTypeParts";

const url = "api/contract/gamingContract/performanceGuaranteeTypeParts";

export const PerformanceGuaranteePartsConfig = simpleLookupManagementConfig({
  lookupEditPermission: "contractLookupModify",
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
  nameSingular: "Performance Guarantee Part",
  objectName: vsObjectName,
  url,
});
